<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-cloud-upload"></i> {{options.title}}
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">

  <div ng2FileDrop
       [uploader]="uploader"
       class="upload-box">
    <h5>
      Drop files here or <a  href="javascript:;" (click)="fileInput.click()"
                             matTooltip="Only files smaller than 10MB are allowed"
                             matTooltipPosition="above"
                             matTooltipClass="text-center"
                             class="upload-button">
      click
    </a> to upload
      <input type="file"
             [accept]="acceptFileExtensions"
             #fileInput
             ng2FileSelect
             [uploader]="uploader"
             multiple class="d-none">
    </h5>
  </div>
  <div class="upload-guide" [innerHTML]="getGuideText()"></div>
  <div class="table-responsive" *ngIf="files.length">
    <table class="table table-condensed" aria-hidden="false">
      <thead>
      <tr>
        <th>Name</th>
        <th>Size</th>
        <th>Progress</th>
        <th>Delete</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let file of files; let i = index">
        <td>{{file.file.name}}</td>
        <td>{{file.file.size | fileSize}}</td>
        <td>
          <mat-progress-bar mode="determinate" [value]="file.progress"></mat-progress-bar>
        </td>
        <td>
          <a (click)="!isUploading && onRemoveFile(file, i)" class="td-btn text-danger" [ngClass]="{disabled:isUploading}">
            <i class="fal fa-trash-alt"></i>
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> cancel
  </button>
  <button (click)="create()" [disabled]="!files.length || isUploading" type="button"
          class="btn btn-success text-uppercase create-btn">
    <i class="fal fa-cloud-upload"></i> upload
  </button>
</div>
